import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "./style.css";
import Home from "./page/Home";
import Test from "./page/Test";
import Yuque from "./page/Yuque";
import PythonTutor from "./page/PythonTutor";
import Xhdtfair from "./page/Xhdtfair";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/embedded" element={<Home />} />
      <Route path="/:oid" element={<Home />} />
      <Route path="/embedded/:oid" element={<Home />} />
      <Route path="/yuque" element={<Yuque />} />
      {/*下掉 <Route path="/xhdtfair" element={<Xhdtfair />} />*/}
      <Route path="/pythontutor" element={<PythonTutor />} />
      <Route path="/test" element={<Test />} />
    </Routes>
  );
};
export default App;
